import { enActivityLogPageTranslations } from './enActivityLogPageTranslations';
import { enAdminTranslations } from './enAdminTranslations';
import { enAuthTranslations } from './enAuthTranslations';
import { enCarLogTranslations } from './enCarLogTranslations';
import { enCohortsPageTranslations } from './enCohortsPageTranslations';
import { enColumnsPageTranslations } from './enColumnsPageTranslations';
import { enCommonTranslations } from './enCommonTranslations';
import { enCopyToEMRTranslations } from './enCopyToEMRTranslations';
import { enCustomerViewTranslations } from './enCustomerViewTranslations';
import { enDownloadsTranslations } from './enDownloadsTranslations';
import { enHepTranslations } from './enHepTranslations';
import { enHomepageTranslations } from './enHomepageTranslations';
import { enNoWorkspaceAccessTranslations } from './enNoWorkspaceAccessTranslations';
import { enParameterLabelsTranslations } from './enParameterLabelsTranslations';
import { enPatientNoteTranslations } from './enPatientNoteTranslations';
import { enPatientOverviewTranslations } from './enPatientOverviewTranslations';
import { enPatientProfileTranslations } from './enPatientProfileTranslations';
import { enPatientRTMTranslations } from './enPatientRTMTranslations';
import { enPatientTabsTranslations } from './enPatientTabsTranslations';
import { enPatientTranslations } from './enPatientTranslations';
import { enPatientTrendsTranslations } from './enPatientTrendsTranslations';
import { enPerceptionParamInfoTranslations } from './enPerceptionParamInfoTranslations';
import { enQuestionnaireTranslations } from './enQuestionnaireTranslations';
import { enRtmBillingTranslations } from './enRtmBillingTranslations';

export const enTranslations = {
  ...enCommonTranslations,
  AllPatients: {
    Header: {
      Filters: {
        columns: 'Columns',
        newColumn: 'New column',
      },
      Actions: {
        addNewPatient: 'Add new patient',
        downloadProgressNotes: 'Download progress notes',
        generateRollup: 'Generate Rollup',
        searchPatients: 'Search Patients',
      },
    },
    columns: {
      patientName: 'Patient name',
      clinicianMonitoringTime: 'Clinician Monitoring Time',
      assistiveDevice: 'Assistive device',
      careLocation: 'Care location',
      patientApp: 'Patient App',
      patientUuid: 'Patient Uuid',
      lastActivity: 'Last Activity',
      location: 'Location',
      surgeryDate: 'Surgery date',
      careActions: 'Care actions',
      clinician: 'Clinician',
      hepAssignment: 'HEP assignment',
      hepExercises_one: '{{count}} exercise',
      hepExercises_other: '{{count}} exercises',
      hepCompletedThisWeek: '{{percent}}% completed this week',
      hepCompletedThisWeekTooltip:
        'Share of this week’s prescribed exercise sessions the patient has completed.',
      hepNotAssigned: 'Not assigned',
      fallRisk: 'Fall risk',
      assessmentNeeded: 'Assessment needed',
      payor: 'Payor',
      phase: 'Phase',
      fallRiskProtocolCompletion: 'Fall risk protocol completion',
      patientActiveDays: 'Patient Active Days',
      typeOfCare: 'Type of care',
      walkScore: 'Walk score',
      progress: 'Progress',
      walkQuality: 'Walk quality',
      walkQualityBands: {
        needs_attention: 'Needs attention',
        limited: 'Limited',
        good: 'Good',
        optimal: 'Optimal',
      },
      workSpace: 'Work space',
      startDate: 'Start Date',
      endDate: 'End Date',
      dischargeDate: 'Discharge date',
      backgroundMonitoring: 'Background Monitoring',
      backgroundMonitoringTooltip: {
        install: 'Install',
        installed: 'Installed',
        uninstalled: 'Uninstalled',
        login: 'Login',
        loggedIn: 'Logged in',
        signedOut: 'Signed out',
        monitoringToggle: 'Monitoring toggle',
        on: 'On',
        off: 'Off',
        backgroundPermission: 'Background permission',
        permissionOk: 'OK',
        revoked: 'Revoked',
        missing: 'Missing',
        mayBeLimited: 'May limit monitoring',
        permissions: {
          ios_location_always: "Location 'Always'",
          ios_motion_and_fitness: 'Motion & Fitness',
          android_physical_activity: 'Physical Activity',
          android_battery_optimization: 'Battery optimization',
        },
        deviceLastSeen: 'Device last seen',
        lastBgWalkSync: 'Last BG walk sync',
        never: 'Never',
      },
    },
  },
  noneOptions: {
    noName: 'No Name',
  },
  inputs: {
    dateInput: {
      oneWeek: '7D',
      oneMonth: '30D',
      custom: 'Custom',
      allDates: 'All',
      yesterday: 'Yesterday',
      today: 'Today',
      tomorrow: 'Tomorrow',
    },
  },
  ...enPatientTranslations,
  ...enCarLogTranslations,
  ...enCopyToEMRTranslations,
  ...enPatientNoteTranslations,
  ...enPatientTabsTranslations,
  ...enPatientProfileTranslations,
  ...enAdminTranslations,
  ...enHomepageTranslations,
  ...enCohortsPageTranslations,
  ...enColumnsPageTranslations,
  ...enPatientOverviewTranslations,
  ...enPatientTrendsTranslations,
  ...enParameterLabelsTranslations,
  ...enQuestionnaireTranslations,
  ...enActivityLogPageTranslations,
  ...enHepTranslations,
  ...enPerceptionParamInfoTranslations,
  ...enPatientRTMTranslations,
  ...enRtmBillingTranslations,
  ...enAuthTranslations,
  ...enDownloadsTranslations,
  ...enNoWorkspaceAccessTranslations,
  ...enCustomerViewTranslations,
};
